/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import styled from "styled-components";
import * as React from "react";
import noFilesImage from "images/EnhanceSpeech/no-files-illustration.svg";
import { devices, fontFamilies } from "components/shared/Styles";

const HeadingSmall = styled.h3`
  font: normal normal bold 16px/24px ${fontFamilies};
  color: var(--spectrum-global-color-static-gray-900);
`;

const Paragraph = styled.p`
  font: normal normal 300 16px/20px ${fontFamilies};
  margin-top: 4px;
  color: var(--spectrum-global-color-static-gray-900);
  text-align: center;
  width: 182px;
`;

const EmptyStateContainer = styled.div`
  grid-area: empty-state;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 32px 0;

  ${devices.small} {
    display: none;
  }
`;

export const EmptyState: React.FC<{
  visible: boolean;
}> = ({ visible }) => {
  if (visible) {
    return (
      <EmptyStateContainer>
        <img style={{ width: "123px" }} src={noFilesImage} />
        <HeadingSmall style={{ marginTop: "24px" }}>
          {I18n.t("enhance_speech.premium.no_files")}
        </HeadingSmall>
        <Paragraph>{I18n.t("enhance_speech.premium.tune")}</Paragraph>
      </EmptyStateContainer>
    );
  } else {
    return <></>;
  }
};
